export * from './product-name-and-image';
